export { HoveringInsertionPromptBox } from "./hovering-insertion-prompt-box";
export type { Props } from "./hovering-insertion-prompt-box";
